import { createScript, createStylesheet } from 'lib/dom-helpers';
import Track, { OnePayEventNames } from 'modules/tracking';
import { AdyenJSsettings } from 'types/transaction-adyen';
import { PAYMENT_METHODS_TYPES } from 'utils/constants';

export interface AdyenWrapper {
  initialize: (adyenOptions: object, paymentMethodOptions?) => Promise<any>;
  adyenCheckout: any;
}

type AdyenPaymentType = typeof PAYMENT_METHODS_TYPES.cc | typeof PAYMENT_METHODS_TYPES.ach;

export class AdyenClient implements AdyenWrapper {
  type: AdyenPaymentType;
  currentWindow: any;
  adyenCheckout: any;

  private constructor(type: AdyenPaymentType, currentWindow = window) {
    this.type = type;
    this.currentWindow = currentWindow;
  }

  static async create(
    adyenJsSettings: AdyenJSsettings,
    type: AdyenPaymentType,
    currentWindow = window,
  ): Promise<AdyenClient> {
    const { adyenCssPath, adyenCssSRI, adyenJsPath, adyenJsSRI } = adyenJsSettings;

    await Promise.all([
      createStylesheet(adyenCssPath, adyenCssSRI, 'anonymous'),
      createScript(adyenJsPath, adyenJsSRI, 'anonymous'),
    ]);

    return new AdyenClient(type, currentWindow);
  }

  initialize = async (adyenOptions, paymentMethodOptions = {}) => {
    try {
      const adyenWeb = this.currentWindow.AdyenWeb;
      this.adyenCheckout = await adyenWeb.AdyenCheckout(adyenOptions);
      if (this.type === PAYMENT_METHODS_TYPES.cc) {
        return new adyenWeb.Card(this.adyenCheckout, {
          showPayButton: true,
          hasHolderName: true,
          holderNameRequired: true,
          hideCVC: false,
          ...paymentMethodOptions,
        });
      } else if (this.type === PAYMENT_METHODS_TYPES.ach) {
        return new adyenWeb.Ach(this.adyenCheckout, {
          showPayButton: true,
          holderNameRequired: true,
        });
      }
    } catch (error) {
      const eventName =
        this.type === PAYMENT_METHODS_TYPES.cc
          ? OnePayEventNames.adyenCCFormFailed
          : OnePayEventNames.adyenACHFormFailed;
      Track(eventName, { error });
    }
  };
}

let AdyenClientCCInstance: AdyenWrapper | undefined = undefined;
export async function loadAdyenCCCheckout(adyenJsSettings: AdyenJSsettings) {
  if (!AdyenClientCCInstance) {
    AdyenClientCCInstance = await AdyenClient.create(adyenJsSettings, PAYMENT_METHODS_TYPES.cc);
  }
  return AdyenClientCCInstance;
}

let AdyenClientACHInstance: AdyenWrapper | undefined = undefined;
export async function loadAdyenACHCheckout(adyenJsSettings: AdyenJSsettings) {
  if (!AdyenClientACHInstance) {
    AdyenClientACHInstance = await AdyenClient.create(adyenJsSettings, PAYMENT_METHODS_TYPES.ach);
  }
  return AdyenClientACHInstance;
}
